import { render, staticRenderFns } from "./nav-tab.vue?vue&type=template&id=136c3693&scoped=true&"
import script from "./nav-tab.vue?vue&type=script&lang=ts&"
export * from "./nav-tab.vue?vue&type=script&lang=ts&"
import style0 from "./nav-tab.vue?vue&type=style&index=0&id=136c3693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c3693",
  null
  
)

export default component.exports